// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// ✅ Element Plus（Vue 3 兼容）
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// ✅ Quill.js 样式和组件（用于显示富文本内容）
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { QuillEditor } from '@vueup/vue-quill'
import error from './error';
// main.ts

// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 注册 QuillEditor 组件
app.component('QuillEditor', QuillEditor)
app.use(error);
app.use(router)
app.use(ElementPlus)
app.mount('#app')